import { $, pageLoaded } from "venuescanner-js/tools/elemental";
import { popup } from "venuescanner-js/vanilla/components/popup";
import { postToApi } from "venuescanner-js/services/api";
import { reportError } from "venuescanner-js/react/services/errorService";
import { emailRegex } from "venuescanner-js/utils/regexes";

const emailIsValid = (input) => input.val().match(emailRegex);

const sendNewletterRequest = async (
  email,
  clearForm = () => {},
  complete = () => {}
) => {
  popup.new(`Adding '${email}' to the newsletter`, { loading: true });

  try {
    await postToApi("addToNewsletter", { email });
    clearForm();
    popup.show(
      `
    <h4>Newsletter</h4>
    <p>Thank you for joining our newsletter, you'll hear from us soon.</p>`,
      { loading: false, success: true, closable: true }
    );
  } catch (e) {
    reportError("new-homepage", e);
    popup.show(
      `We ran into an error signing you up. Our developers have been informed. Please could you try again?`,
      { loading: false, success: false, closable: true }
    );
  }
  complete();
};
const newsletter = function (element) {
  const input = $(element).find("input");
  const button = $(element).find("button");
  button.prop("disabled", !emailIsValid(input));
  input.bind("keyup", () => {
    button.prop("disabled", !emailIsValid(input));
  });
  button.click(() => {
    sendNewletterRequest(
      input.val(),
      () => {
        input.val("");
        button.prop("disabled", !emailIsValid(input));
      },
      () => {
        button.prop("disabled", !emailIsValid(input));
      }
    );
  });
};
pageLoaded(() => {
  $(".newsletter-form").each(newsletter);
});
